import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initLicenseSlider = () => {
  const slider = document.querySelector("[data-license-slider]");
  if (!slider) return;

    new Swiper(slider, {
      lazy: true,
      watchOverflow: true,
      speed: 700,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: slider.querySelector(".slider-navigation__button--next"),
        prevEl: slider.querySelector(".slider-navigation__button--prev"),
      },
    });
};

export default initLicenseSlider;
